export default __webpack_public_path__ + "static/part-time-advantage-4-1a20f3c33916191830212ba7244db30f.png";